import React from 'react';
import './Details.css'

const Details = (props) => {
    const {details} = props;
    let addBook = 0;
    let poetName = '';
    console.log(details);
    for(const addpoet of details){
        addBook = addBook + addpoet.available;
        poetName = poetName + addpoet.name;
    }

    let freeBook;
    if(addBook >= 50){
        const countFree = parseInt(addBook / 50);
        freeBook = countFree;
    }
    else{
        freeBook = 0;
    }
    const totalBook = addBook + freeBook;
    return (
        <div>
            <h4>Selected Book to Take:</h4>
            <p>Poet Added: {props.details.length}</p>
            <p>Free Book: {freeBook}<br /><span className="free-book">(you will get 1 free book per 50 books)</span></p>
            <p>Book Added: {addBook}</p>
            <p>Total book you take: {totalBook}</p>
            <p>Taken book writers:</p>
            <p>{poetName} <br /></p>
        </div>
    );
};

export default Details;